/**
 * @generated SignedSource<<125aed570ca4723cb0eedc8f91314b88>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AttachBlockContentUsageSearchBody_PaginationFragment$data = {
  readonly contentUsages: {
    readonly __id: string;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"AttachBlockContentUsageModalListItem_ContentUsageFragment">;
      };
    }>;
    readonly totalCount: number;
  };
  readonly id: string;
  readonly " $fragmentType": "AttachBlockContentUsageSearchBody_PaginationFragment";
};
export type AttachBlockContentUsageSearchBody_PaginationFragment$key = {
  readonly " $data"?: AttachBlockContentUsageSearchBody_PaginationFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"AttachBlockContentUsageSearchBody_PaginationFragment">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "contentUsages"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "contentLabelIds"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "contentTypes"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "excludeContentTypes"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "search"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./AttachBlockContentUsageSearchBodyPaginationQuery.graphql'),
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "AttachBlockContentUsageSearchBody_PaginationFragment",
  "selections": [
    (v1/*: any*/),
    {
      "alias": "contentUsages",
      "args": [
        {
          "kind": "Variable",
          "name": "contentLabelIds",
          "variableName": "contentLabelIds"
        },
        {
          "kind": "Variable",
          "name": "contentTypes",
          "variableName": "contentTypes"
        },
        {
          "kind": "Variable",
          "name": "excludeContentTypes",
          "variableName": "excludeContentTypes"
        },
        {
          "kind": "Variable",
          "name": "search",
          "variableName": "search"
        }
      ],
      "concreteType": "ContentUsageNodeConnection",
      "kind": "LinkedField",
      "name": "__AttachBlockContentUsageSearchBody__contentUsages_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ContentUsageNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ContentUsage",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "AttachBlockContentUsageModalListItem_ContentUsageFragment"
                },
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfoObjectType",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
})();

(node as any).hash = "d065fc304c27fd5a277d706d70822ce8";

export default node;
